export { OptimizelyDecideOption } from '@optimizely/optimizely-sdk';
export { OPTIMIZELY_COOKIE_NAME, OPTIMIZELY_COOKIE_MAX_AGE, } from './optimizely.consts';
export { getDecision, getExperimentVariables, getExperimentVariationKey, getOptimizelyUserId, isExperimentEnabled, Optimizely, } from './optimizely';
//# sourceMappingURL=index.js.map